import { render, staticRenderFns } from "./SnackbarComponent.vue?vue&type=template&id=417f8510&"
import script from "./SnackbarComponent.vue?vue&type=script&lang=ts&"
export * from "./SnackbarComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('417f8510')) {
      api.createRecord('417f8510', component.options)
    } else {
      api.reload('417f8510', component.options)
    }
    module.hot.accept("./SnackbarComponent.vue?vue&type=template&id=417f8510&", function () {
      api.rerender('417f8510', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SnackbarComponent.vue"
export default component.exports